export default __webpack_public_path__ + "static/media/device_marker_red.4215bbce.svg";